import { render } from "./App.vue?vue&type=template&id=fb92da00"
const script = {}

import exportComponent from "E:\\vue\\fsl240322\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__